import React from 'react';
import { Tool, type ToolArgsWithController } from '@aha-app/aha-editor-v2';
import { whiteboardControllerForEditor } from '../EmbeddedWhiteboardControllersPluginFactory';

class ToolShowWhiteboardComments extends Tool {
  static toolName = 'Show comments';

  static available(toolArgs: ToolArgsWithController): boolean {
    const whiteboardController = whiteboardControllerForEditor(
      toolArgs.controller.ahaEditor,
      toolArgs.element
    );

    return (whiteboardController?.state.unresolvedCommentsCount || 0) > 0;
  }

  static renderToolbarButtonIcon(
    toolArgs: ToolArgsWithController
  ): JSX.Element {
    const whiteboardController = whiteboardControllerForEditor(
      toolArgs.controller.ahaEditor,
      toolArgs.element
    );
    const unresolvedCommentsCount =
      whiteboardController?.state.unresolvedCommentsCount || 0;

    return (
      <span className='tw-px-1'>
        <i className='fa-solid fa-comment' />
        {unresolvedCommentsCount > 0 && ` ${unresolvedCommentsCount}`}
      </span>
    );
  }

  static action({ controller, element }: ToolArgsWithController): void {
    const whiteboardController = whiteboardControllerForEditor(
      controller.ahaEditor,
      element
    );

    if (whiteboardController) {
      const commentsUrl = whiteboardController.getDisplayModeUrl(
        'fullscreen',
        '#sidepanel-comments'
      );
      whiteboardController.router.navigate(commentsUrl);
    }
  }
}

export default ToolShowWhiteboardComments;
